var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",class:{under: _vm.is_under}},[_vm._v(_vm._s(_vm.to_text))])}
var staticRenderFns = []

export { render, staticRenderFns }